module.exports = __webpack_public_path__ + "static/img/sectigo-siteseal.2bb6921.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/footer/sectigo-siteseal.svg
// module id = 1823
// module chunks = 1